import token from 'styled-token';
import { addSuffix } from '../util/addSuffix';

/** @mixin fontSizeMixin */
/**
 * Get the font size for the given font type.
 *
 * @example
 * import { fontSizeMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     font-size: ${fontSizeMixin('h1')};
 * `;
 *
 * <Component>h1 font size</Component>
 *
 * @method
 * @param {string} fontType - The `fontType` key for the `fontSizes` object.
 * @param {function} [callback] - An optional callback that will be called with an object with the
 *     font size value and suffix properties. The value returned from the function will be inserted.
 * @return {Interpolation}
 */
export var fontSizeMixin = function fontSizeMixin(fontType, callback) {
  return token({
    fontSizes: 'fontSizes',
    suffix: 'defaultUnit'
  }, function (_ref) {
    var fontSizes = _ref.fontSizes,
      suffix = _ref.suffix;
    var value = fontSizes && fontSizes[fontType];
    if (typeof callback === 'function') {
      return callback({
        value: value,
        suffix: suffix
      });
    }
    return addSuffix(value, suffix);
  });
};